const sanitizeTitleFromURL = (title: string): string => {
  return title
    .split(/-| /)
    .map((word) => {
      const lowerCaseWord = word.toLowerCase();
      const result =
        lowerCaseWord.charAt(0).toUpperCase() + lowerCaseWord.slice(1);
      return result;
    })
    .join(" ");
};

export interface IbreadcrumbObject {
  label: string;
  link: string;
}

export const breadcrumbObjectFromURL = (): IbreadcrumbObject[] => {
  const breadcrumbObjects = [
    {
      label: "Home",
      link: "/",
    },
  ];
  const pathNameArray = window.location.pathname.split("/").filter((el) => {
    return el !== "";
  });

  pathNameArray.forEach((el, index) => {
    const isLastItem = index === pathNameArray.length - 1;
    breadcrumbObjects.push({
      label: sanitizeTitleFromURL(el),
      link: isLastItem
        ? ""
        : "/" + pathNameArray.slice(0, index + 1).join("/"),
    });
  });

  return breadcrumbObjects;
}